<script >
import { use } from '@fegobull/webapi';
import { TaskComponentClient } from '@futuweb/task-component-client';
import { onMounted, ref } from 'vue-demi';
import getProxyApi from '../../api';
const __sfc_main = {};
__sfc_main.props = {
  encryptConfig: {
    type: String,
    required: true
  },
  isDark: {
    type: Boolean,
    default: false
  },
  isHide: {
    type: Boolean,
    default: false
  },
  market: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useLang
  } = use;
  const {
    lang
  } = useLang();
  function getLangText(langCode) {
    const langMap = {
      0: 'zh-cn',
      //eslint-disable-line @typescript-eslint/no-magic-numbers
      1: 'zh-hk',
      //eslint-disable-line @typescript-eslint/no-magic-numbers
      2: 'en-us',
      //eslint-disable-line @typescript-eslint/no-magic-numbers
      5: 'ja' //eslint-disable-line @typescript-eslint/no-magic-numbers
    };
    return langMap[langCode] || '';
  }
  const actId = ref('');
  const props = __props;
  function setTaskStatus(task) {
    const {
      useVariable
    } = use;
    const FEGODATA = useVariable();
    task.forEach(item => {
      const taskId = item.task_id || item.pkg_id;
      const status = item.isFinished ? 'FINISHED' : 'WAITING';
      const key = `task_${taskId}`;
      FEGODATA[key] = status;
      console.log(`set task ${key}`, status);
      if (item.task_list) {
        setTaskStatus(item.task_list);
      }
    });
  }
  function formatTask(task) {
    console.log('formatTask', task);
    setTaskStatus(task);
    const originalTaskFormat = window._act_group_task_center_task_list_original_task_format;
    return originalTaskFormat ? originalTaskFormat(task) : task;
  }
  function getFtReportIns() {
    return window.FEGORender?.plugins?.ftReport?.ftReportIns;
  }
  onMounted(async () => {
    const {
      apiPath,
      actId: actIdValue
    } = await getProxyApi(props.encryptConfig, props.market);
    window._params = Object.assign(window._params || {}, {
      taskCommonApiPath: apiPath
    });
    actId.value = actIdValue;
  });
  return {
    lang,
    getLangText,
    actId,
    formatTask,
    getFtReportIns
  };
};
__sfc_main.components = Object.assign({
  TaskComponentClient
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <TaskComponentClient v-if="actId"
                         v-show="!isHide"
                         :act-id="actId"
                         :is-dark="isDark"
                         :lang="getLangText(lang)"
                         :ft-report-ins="getFtReportIns()"
                         :format-task="formatTask">
    </TaskComponentClient>
</template>
